<ng-container *ngIf="main">
    <material-button
        *ngIf="!isNewUI"
        [classList]="['nav-item', 'settingsGearIcon']"
        [buttonType]="'icon'"
        [prefixIconType]="'image'"
        (mouseenter)="openSettingsMenu()"
        [titleText]="'Settings'"
        [hideRipple]="true"
        [prefixImgClassList]="['!w-auto', '!h-auto', '!max-w-none', '!max-h-none']"
        [prefixImgSrc]="isSettingsSelected ? '/assets/images/new-ui/settings-green.png' : '/assets/images/new-ui/settings.png'"
        [suffixIconClassList]="['!text-[24px]']"
        [suffixIcon]="'arrow_drop_down'"
        [matMenu]="settingsMenu"
        [buttonPurpose]="'MENU_TRIGGER'"
        (menuTriggerElementEmit)="onMenuTrigger($event)"></material-button>
    <material-button
        *ngIf="isNewUI"
        [classList]="['header-button', 'settingsGearIcon']"
        [buttonType]="'icon'"
        [prefixIconType]="'image'"
        (mouseenter)="openSettingsMenu()"
        [titleText]="'Settings'"
        [hideRipple]="true"
        [prefixImgClassList]="['!w-auto', '!h-auto', '!max-w-none', '!max-h-none']"
        [prefixImgSrc]="'/assets/images/new-ui/settings.png'"
        [suffixIconClassList]="['!text-[24px]']"
        [suffixIcon]="'arrow_drop_down'"
        [matMenu]="settingsMenu"
        [buttonPurpose]="'MENU_TRIGGER'"
        (menuTriggerElementEmit)="onMenuTrigger($event)"></material-button>
</ng-container>

<ng-container *ngIf="!main">
    <button
        *transloco="let translate"
        (mouseenter)="openSettingsMenu(menu)"
        (mouseleave)="closeSettingsMenu()"
        mat-menu-item
        (click)="setRoute(menu)"
        class="headerSettingItem settingsGearIcon !text-[#000000c9] hover:!bg-[#0000000a]"
        [class.activeSetting]="menu.selected"
        [matMenuTriggerFor]="settingsMenu"
        #matSettingsMenuTrigger="matMenuTrigger"
        [title]="!menu.noTranslation ? translate(menu.name) : menu.name">
        <mat-icon class="!text-[#0000008a]" [hidden]="!menu.icon" [textContent]="menu.icon"></mat-icon>
        <span [textContent]="!menu.noTranslation ? translate(menu.name) : menu.name"></span>
    </button>
</ng-container>

<mat-menu
    #settingsMenu="matMenu"
    [class]="'!bg-white !mt-[5px] !max-h-[70vh] !border-t-2 !border-[#00a651] settingsMenuContainer ' + (main ? '' : 'noTopBorder')"
    [overlapTrigger]="false">
    <span (mouseleave)="closeSettingsMenu()">
        <div [hidden]="!menu.childrenLoading" class="showingLoaderIcon">
            <img *ngIf="!isIE" src="/assets/images/loader.svg" alt="Loading..." />
            <mat-spinner *ngIf="isIE"></mat-spinner>
        </div>
        <div *transloco="let translate">
            <ng-container *ngFor="let item of menu.children">
                <ng-container *ngIf="item.hasChildren">
                    <app-settings-nested-menu
                        [menu]="item"
                        (childMenuClosedEvent)="childMenuClosedEventListener()"></app-settings-nested-menu>
                </ng-container>
                <ng-container *ngIf="!item.hasChildren">
                    <button
                        (mouseenter)="openSettingsMenu(item)"
                        mat-menu-item
                        (click)="setRoute(item)"
                        class="headerSettingItem !text-[#000000c9] hover:!bg-[#0000000a]"
                        [class.activeSetting]="item.selected"
                        [title]="!item.noTranslation ? translate(item.name) : item.name">
                        <mat-icon class="!text-[#0000008a]" [hidden]="!item.icon" [textContent]="item.icon"></mat-icon>
                        <span [textContent]="!item.noTranslation ? translate(item.name) : item.name"></span>
                    </button>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="menu.children?.length === 0 && !menu.childrenLoading">
                <button mat-menu-item class="headerSettingItem">
                    <span [textContent]="translate('No Records Found')"></span>
                </button>
            </ng-container>
        </div>
    </span>
</mat-menu>
